// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"StocksPage_Wrapper__4d3yg","Container":"StocksPage_Container__3su_G"};